import React, { useEffect, useState } from 'react';
import { Alert, Button, Spinner, Table } from 'react-bootstrap';
import { HiRefresh } from 'react-icons/hi';
import apiService from '../services/apiService';

const HistoricoRodadas = () => {
    const [rodadas, setRodadas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [refresh, setRefresh] = useState(0);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError('');
        apiService.listarRodadas()
            .then(response => { if (!cancelled) setRodadas(response.rodadas); })
            .catch(err => { if (!cancelled) setError(err.message || 'Não foi possível carregar o histórico.'); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [refresh]);

    const cellStyle = { textAlign: 'center', padding: '12px' };
    return (
        <div className="flex-1 bg-white h-full flex flex-col overflow-hidden">
            <div className="bg-gradient-to-r from-slate-700 to-slate-600 text-white px-6 py-4 h-20 flex items-center justify-between flex-shrink-0">
                <span className="text-lg font-semibold">Histórico de rodadas</span>
                <Button
                    variant="outline-light"
                    size="sm"
                    disabled={loading}
                    onClick={() => setRefresh(value => value + 1)}
                    title="Atualizar histórico"
                    aria-label="Atualizar histórico"
                >
                    <HiRefresh className={`w-5 h-5${loading ? ' animate-spin' : ''}`} aria-hidden="true" />
                </Button>
            </div>
            <div className="p-4 overflow-auto">
                <p className="text-muted">Suas últimas 15 rodadas, da mais recente para a mais antiga. Cada “Aplicar filtros” salva a rodada automaticamente; ao atingir o limite, a mais antiga é apagada.</p>
                {error ? (
                    <Alert variant="danger">{error}</Alert>
                ) : loading ? (
                    <div className="text-center py-4"><Spinner animation="border" role="status"><span className="visually-hidden">Carregando histórico...</span></Spinner></div>
                ) : rodadas.length === 0 ? (
                    <div className="text-center py-4 text-muted">Nenhuma rodada salva. As rodadas são salvas automaticamente ao aplicar os filtros.</div>
                ) : (
                    <div style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '8px', overflow: 'hidden' }}>
                        <Table responsive bordered className="no-hover-table" style={{ margin: 0 }}>
                            <thead style={{ backgroundColor: '#e9ecef' }}>
                                <tr>
                                    <th scope="col" style={cellStyle}>Data e hora</th>
                                    <th scope="col" style={cellStyle}>Identificador</th>
                                    <th scope="col" style={cellStyle}>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rodadas.map(rodada => (
                                    <tr key={rodada.identificador}>
                                        <td style={cellStyle}>{new Date(rodada.data).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}</td>
                                        <td style={{ ...cellStyle, overflowWrap: 'anywhere' }}>{rodada.identificador}</td>
                                        <td style={cellStyle}>
                                            <Button as="a" size="sm" style={{ backgroundColor: '#003B6B', borderColor: '#003B6B', padding: '8px 25px', fontWeight: 'bold', borderRadius: '8px' }}
                                                href={`/?rodada=${encodeURIComponent(rodada.identificador)}`}
                                                target="_blank" rel="noopener noreferrer" title="Abrir rodada em nova aba">
                                                Abrir
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HistoricoRodadas;
